import { useContext } from 'react'

import FirebaseContext from 'context/provider/firebase'

const useFirebase = () => {
  return useContext(FirebaseContext)
}

export default useFirebase